
import _range from 'lodash/range'

import moment from 'moment-timezone'

import { DAYS_OF_THE_WEEK_MAP } from '@/helpers/dates'

const NUMBER_MONTHS_VISIBLE_DEFAULT = 2

export default {
  name: 'Calendar',
  props: {
    value: Object,
    dates: Object,
    reservationAllowedDateRange: {}, // Setting Array type here was freaking out tslint for some reason
    numberOfDaysSelectableIntoFuture: Number,
  },
  data() {
    const date = (this.value || {}).value || moment()
    let currentYear = date.get('year')
    let currentMonthIndex = date.get('month')
    const numberOfMonthsVisible = NUMBER_MONTHS_VISIBLE_DEFAULT
    const updatedMonthIndex = currentMonthIndex + numberOfMonthsVisible - 1
    const updatedYear = currentYear + Math.floor(updatedMonthIndex / 12)

    if (
      !this.dates[updatedYear] ||
      !this.dates[updatedYear][updatedMonthIndex % 12]
    ) {
      currentMonthIndex = currentMonthIndex - 1
      currentYear = currentYear + Math.floor(currentMonthIndex / 12)
      currentMonthIndex = (currentMonthIndex + 12) % 12
    }

    return {
      currentYear,
      currentMonthIndex,
      numberOfMonthsVisible,
    }
  },
  computed: {
    monthsVisible() {
      return _range(
        this.currentMonthIndex,
        this.currentMonthIndex + this.numberOfMonthsVisible
      ).map(month => {
        const year = this.currentYear + Math.floor(month / 12)
        const monthIndex = month % 12
        const monthName = this.getMonthName(monthIndex, year)
        return {
          monthIndex,
          month: monthName,
          year,
        }
      })
    },
    months() {
      return this.monthsVisible.map(month => {
        const firstDayOfTheMonth = moment([
          month.year,
          month.monthIndex,
          1,
          0,
          0,
          0,
        ])
        const firstDayIndex = firstDayOfTheMonth.get('day')

        return {
          ...month,
          days: _range(0, 42).map(dayIndex => {
            const dayNumber = dayIndex - firstDayIndex + 1
            return this.dates[month.year][month.monthIndex][dayNumber] || {}
          }),
        }
      })
    },
  },
  methods: {
    showPreviousMonthButton(month, monthIndex) {
      const date = moment([month.year, month.monthIndex, 1, 0, 0, 0])
      const today = moment()

      return (
        monthIndex === 0 &&
        (date.get('month') > today.get('month') ||
          date.get('year') > today.get('year'))
      )
    },
    showNextMonthButton() {
      const updatedMonthIndex =
        this.currentMonthIndex + this.numberOfMonthsVisible
      const updatedYear = this.currentYear + Math.floor(updatedMonthIndex / 12)

      return (
        this.dates[updatedYear] &&
        this.dates[updatedYear][updatedMonthIndex % 12]
      )
    },
    goToPreviousMonth() {
      this.currentYear =
        this.currentYear + Math.floor((this.currentMonthIndex - 1) / 12)
      this.currentMonthIndex = (this.currentMonthIndex - 1 + 12) % 12
    },
    goToNextMonth() {
      this.currentYear =
        this.currentYear + Math.floor((this.currentMonthIndex + 1) / 12)
      this.currentMonthIndex = (this.currentMonthIndex + 1) % 12
    },
    selected(day) {
      return this.value && this.value.label === day.label
    },
    getMonthName(monthIndex: number, year: number) {
      return moment([year, monthIndex, 1, 0, 0, 0]).format('MMMM')
    },
    mapDayOfTheWeek: dayOfTheWeek => DAYS_OF_THE_WEEK_MAP[dayOfTheWeek - 1],
    onCircleClicked(day) {
      if (day.passed) {
        return
      }
      console.log(day)

      this.$emit('input', day)
    },
  },
}
